import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import {InputParameterListComponent} from '@catmodules/models/parameters/components/input-parameter-list/input-parameter-list.component';
import { ParametersService } from '@catmodules/models/parameters/services/parameters.service';
import { UIBaseModule } from '@catui/ui-base.module';
import { UIFormModule } from '@catuiform/ui-form.module';
import { InputParameterComponent } from './components/input-parameter/input-parameter.component';
import {DataTableModule} from "primeng/primeng";
import { ParameterListComponent } from './components/parameter-list/parameter-list.component';
import { ModifyParameterComponent } from './components/modify-parameter/modify-parameter.component';

const publicComponents = [
  InputParameterComponent,
  InputParameterListComponent,
  ParameterListComponent,
  ModifyParameterComponent
];

const declarations = [
  ...publicComponents,
];

const imports = [
  CommonModule,
  FormsModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
  DataTableModule
];

const exportings = [...publicComponents];

const providers = [ParametersService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class ParametersModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/parameters/parameters.module.ts